import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// FIX: Import ToastContainer and CSS from react-toastify instead of react-hot-toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";

// Import Public Routes
import PublicRoutes from "./routes/PublicRoutes";
import ScrollToTop from "./components/common/ScrollToTop";
import StudentBottomNav from "./components/student/StudentBottomNav";

// Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";
import AdminChat from "./pages/admin/AdminChat";
import CourseManagement from "./pages/admin/courses/CourseManagement";
import CourseDetails from "./pages/admin/courses/CourseDetails";
import CreateCourse from "./pages/admin/courses/CreateCourse";
import EditCourse from "./pages/admin/courses/EditCourse";
import StudentManagement from "./pages/admin/students/StudentManagement";
// import FeeManagement from "./pages/admin/students/FeeManagement";
import StudentDetails from "./pages/admin/students/StudentDetails";
import VerificationRequests from "./pages/admin/students/VerificationRequests";
import MaterialManager from "./pages/admin/courses/materials/MaterialManager";
import ManageStudent from "./pages/admin/students/ManageStudent";
import EditStudentForm from "./pages/admin/students/EditStudentForm";
import InquiryManagement from "./pages/admin/inquiries/InquiryManagement";
import BatchManagement from "./pages/admin/batches/BatchManagement";
import BatchDetails from "./pages/admin/batches/BatchDetails";
import CertificateManagement from "./pages/admin/certificates/CertificateManagement";
import ContactMessages from "./pages/admin/ContactMessages";
import WebinarManagement from "./pages/admin/WebinarManagement"; // NEW IMPORT
import CreateWebinar from "./pages/admin/webinars/CreateWebinar";
import EditWebinar from "./pages/admin/webinars/EditWebinar";
import BlogManagement from "./pages/admin/BlogManagement";
import CreateBlog from "./pages/admin/blog/CreateBlog";
import EditBlog from "./pages/admin/blog/EditBlog";
import NewsletterManagement from "./pages/admin/NewsletterManagement";
import ManageProjects from "./pages/admin/projects/ManageProjects";
import AdminAddProject from "./pages/admin/projects/AdminAddProject";
import AdminEditProject from "./pages/admin/projects/AdminEditProject";
import ManageProjectOrders from "./pages/admin/projects/ManageProjectOrders";
// Notes Admin Pages
import NotesManagement from "./pages/admin/notes/NotesManagement";
import CreateTopic from "./pages/admin/notes/CreateTopic";
import EditTopic from "./pages/admin/notes/EditTopic";

// Attendance Admin Pages
import DailyAttendance from "./pages/admin/attendance/DailyAttendance";
import AttendanceHistory from "./pages/admin/attendance/AttendanceHistory";

// Student Pages
import StudentDashboard from "./pages/student/StudentDashboard";
import MyCourses from "./pages/student/MyCourses";
import CourseView from "./pages/student/CourseView";
import Payments from "./pages/student/Payments";
import TransactionHistory from "./pages/student/TransactionHistory";
import AvailableCourses from "./pages/student/AvailableCourses";
import StudentCourseDetails from "./pages/student/StudentCourseDetails";
import StudentProfile from "./pages/student/StudentProfile";
import StudentAssignmentsPage from "./pages/student/StudentAssignmentsPage";
import StudentAssignmentDetail from "./pages/student/components/StudentAssignmentDetail";
import NotesHub from "./pages/student/NotesHub";
import StudentChat from "./pages/student/StudentChat";

import TestManagement from "./pages/admin/tests/TestManagement";
import CreateTest from "./pages/admin/tests/CreateTest";
import StudentTests from "./pages/student/StudentTests";
import TakeTest from "./pages/student/TakeTest";
import TestResult from "./pages/student/TestResult";
import EditTest from "./pages/admin/tests/EditTest";
import TestResults from "./pages/admin/tests/TestResults";

// Common Components
import PrivateRoute from "./components/common/PrivateRoute";

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* FIX: Replaced Toaster with ToastContainer from react-toastify */}
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />

        <ScrollToTop />

        <Routes>
          {/* ===== PUBLIC ROUTES ===== */}
          <Route path="/*" element={<PublicRoutes />} />

          {/* ===== ADMIN ROUTES ===== */}
          <Route
            path="/admin"
            element={
              <PrivateRoute role="admin">
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/chat"
            element={
              <PrivateRoute role="admin">
                <AdminChat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/courses"
            element={
              <PrivateRoute role="admin">
                <CourseManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/courses/create"
            element={
              <PrivateRoute role="admin">
                <CreateCourse />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/courses/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditCourse />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/courses/:id"
            element={
              <PrivateRoute role="admin">
                <CourseDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/verification"
            element={
              <PrivateRoute role="admin">
                <VerificationRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/courses/:id/materials"
            element={
              <PrivateRoute role="admin">
                <MaterialManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/students"
            element={
              <PrivateRoute role="admin">
                <StudentManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/students/:id"
            element={
              <PrivateRoute role="admin">
                <StudentDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/students/manage"
            element={
              <PrivateRoute role="admin">
                <ManageStudent />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/students/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditStudentForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/inquiries"
            element={
              <PrivateRoute role="admin">
                <InquiryManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/batches"
            element={
              <PrivateRoute role="admin">
                <BatchManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/batches/:id"
            element={
              <PrivateRoute role="admin">
                <BatchDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/certificates"
            element={
              <PrivateRoute role="admin">
                <CertificateManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/contact-messages"
            element={
              <PrivateRoute role="admin">
                <ContactMessages />
              </PrivateRoute>
            }
          />
          {/* NEW: Webinar Management Route */}
          <Route
            path="/admin/webinars"
            element={
              <PrivateRoute role="admin">
                <WebinarManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/webinars/create"
            element={
              <PrivateRoute role="admin">
                <CreateWebinar />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/webinars/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditWebinar />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/blog"
            element={
              <PrivateRoute role="admin">
                <BlogManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/blog/create"
            element={
              <PrivateRoute role="admin">
                <CreateBlog />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/blog/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditBlog />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/newsletter"
            element={
              <PrivateRoute role="admin">
                <NewsletterManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <PrivateRoute role="admin">
                <ManageProjects />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/projects/add"
            element={
              <PrivateRoute role="admin">
                <AdminAddProject />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/projects/edit/:id"
            element={
              <PrivateRoute role="admin">
                <AdminEditProject />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/project-orders"
            element={
              <PrivateRoute role="admin">
                <ManageProjectOrders />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/tests"
            element={
              <PrivateRoute role="admin">
                <TestManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tests/create"
            element={
              <PrivateRoute role="admin">
                <CreateTest />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tests/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditTest />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tests/results/:testId"
            element={
              <PrivateRoute role="admin">
                <TestResults />
              </PrivateRoute>
            }
          />

          {/* ===== NOTES ADMIN ROUTES ===== */}
          <Route
            path="/admin/notes"
            element={
              <PrivateRoute role="admin">
                <NotesManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/notes/create"
            element={
              <PrivateRoute role="admin">
                <CreateTopic />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/notes/edit/:id"
            element={
              <PrivateRoute role="admin">
                <EditTopic />
              </PrivateRoute>
            }
          />

          {/* ===== ATTENDANCE ADMIN ROUTES ===== */}
          <Route
            path="/admin/attendance/daily"
            element={
              <PrivateRoute role="admin">
                <DailyAttendance />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/attendance/history"
            element={
              <PrivateRoute role="admin">
                <AttendanceHistory />
              </PrivateRoute>
            }
          />

          {/* ===== STUDENT ROUTES ===== */}
          <Route
            path="/student"
            element={
              <PrivateRoute role="student">
                <StudentDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/courses"
            element={
              <PrivateRoute role="student">
                <MyCourses />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/courses/:id"
            element={
              <PrivateRoute role="student">
                <CourseView />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/payments"
            element={
              <PrivateRoute role="student">
                <Payments />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/history"
            element={
              <PrivateRoute role="student">
                <TransactionHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/available"
            element={
              <PrivateRoute role="student">
                <AvailableCourses />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/course/:id"
            element={
              <PrivateRoute role="student">
                <StudentCourseDetails />
              </PrivateRoute>
            }
          />

          <Route
            path="/student/profile"
            element={
              <PrivateRoute role="student">
                <StudentProfile />
              </PrivateRoute>
            }
          />

          <Route
            path="/student/assignments"
            element={
              <PrivateRoute role="student">
                <StudentAssignmentsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/assignments/:id"
            element={
              <PrivateRoute role="student">
                <StudentAssignmentDetail />
              </PrivateRoute>
            }
          />

          <Route
            path="/student/tests"
            element={
              <PrivateRoute role="student">
                <StudentTests />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/take-test/:attemptId"
            element={
              <PrivateRoute role="student">
                <TakeTest />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/test-result/:attemptId"
            element={
              <PrivateRoute role="student">
                <TestResult />
              </PrivateRoute>
            }
          />

          {/* ===== NOTES STUDENT ROUTE ===== */}
          <Route
            path="/student/notes"
            element={
              <PrivateRoute role="student">
                <NotesHub />
              </PrivateRoute>
            }
          />
          <Route
            path="/student/chat"
            element={
              <PrivateRoute role="student">
                <StudentChat />
              </PrivateRoute>
            }
          />

          {/* ===== DEFAULT ROUTES ===== */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <StudentBottomNav />
      </AuthProvider>
    </Router>
  );
}

export default App;